import React from 'react';
import RadioPage from '@domain/pages/RadioPage';

const extraDamage = 'extraDamage';

function ExtraDamage() {

  const fields = [{
    id: 1,
    value: 'yes',
    triggerKeys: [106, 74, 49],
    label: 'Ja'
  }, {
    id: 2,
    value: 'no',
    triggerKeys: [110, 78, 50],
    label: 'Nee'
  }
  ]

  return <RadioPage fieldName={extraDamage} styleLabel={'extraDamage'} fields={fields} />
}

export default ExtraDamage;